// src/components/managesubs/SubscriptionHeader.js
import React from "react";
import { Link } from "react-router-dom";
import { Database } from "lucide-react";
import { useAuth } from "../../context/Authcontext";
import { useNavigate } from 'react-router-dom';
import { createPortalSession } from "../../api/stripe/stripe";
const SubscriptionHeader = () => {
  const { isAuthenticated, logout } = useAuth();
  const navigate = useNavigate();

  const handleManageMySubscription = async () => {
    try {
      const result = await createPortalSession();
      //window.open(result.url, '_blank');
    } catch (error) {
      console.error("Error creating portal session:", error);
    }

  }
  const handleLogout = () => {
    logout();
    navigate('/', { replace: true });
  }
  return (
    <header className="bg-white bg-opacity-70 shadow-sm border-b fixed w-full z-10 backdrop-blur-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex justify-between items-center">
          <div className="flex items-center">
          <Link to= "/" className="w-10 h-10 rounded-full mr-3 overflow-hidden flex items-center justify-center bg-blue-600">
          
          <img src="/logo.jpg" alt="Logo" className="w-full h-full object-cover" />
          </Link>
          <Link to="/" className="text-xl font-bold text-gray-900">
          <span>DealGrid</span>
          </Link>
            {/* <span  className="text-xl font-bold text-gray-900">US Real Estate Data</span> */}
          </div>
          <nav className="hidden md:flex space-x-8">
            <Link
              to="/manage-subscription"
              className="text-gray-600 hover:text-blue-600 transition-colors">
              manage my Subscription
            </Link>
            <Link
              to="/datastats"
              className="text-gray-600 hover:text-blue-600 transition-colors">
              Extract Data
            </Link>
          </nav>
          <div>
            <div className="flex space-x-4">
              <Link to="/" className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 hover:scale-105 transition-transform">
                Get Started
              </Link>

              <button
                onClick={handleLogout}
                className="bg-gray-200 text-red-600 px-6 py-2 rounded-lg hover:bg-gray-300 hover:scale-105 transition-transform"
              >
                Log Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default SubscriptionHeader;